/* eslint-disable no-console */
import {Table} from 'antd';
import React from 'react';

import useJSONStore from '../../../store/StaticJson/jsonStore';
import {formatIndian} from '../../../utils/formatIndian';
import {
  RawMaterialKey,
  RawMaterialLabel
} from '../../Forms/Constants/Products/RawMaterialKeyAndLabel';

const RawMaterialDis: React.FC<{dataSource: any; suppliers: any}> = ({
  dataSource,
  suppliers
}) => {
  const vehicleType = useJSONStore.getState().vehicleType;
  const columns: any = [
    {
      title: RawMaterialLabel.SUPPLIER_ID,
      dataIndex: RawMaterialKey.SUPPLIER_ID,
      width: 120,
      render: (value: any) => {
        return (
          <>
            {
              suppliers.find((item: any) => {
                return item.value === value;
              })?.label
            }
          </>
        );
      }
    },
    {
      title: RawMaterialLabel.FUEL_EMISSION,
      dataIndex: RawMaterialKey.FUEL_EMISSION,
      width: 120,
      render: (value: any) => {
        return formatIndian(value);
      }
    },
    {
      title: RawMaterialLabel.ELEC_EMISSION,
      dataIndex: RawMaterialKey.ELEC_EMISSION,
      width: 120,
      render: (value: any) => {
        return formatIndian(value);
      }
    },
    {
      title: RawMaterialLabel.WASTE_EMISSION,
      dataIndex: RawMaterialKey.WASTE_EMISSION,
      width: 120,
      render: (value: any) => {
        return formatIndian(value);
      }
    },
    {
      title: RawMaterialLabel.VEHICLE_TYPE,
      dataIndex: RawMaterialKey.VEHICLE_TYPE,
      width: 120,
      render: (value: any) => {
        return (
          <>
            {
              vehicleType.find((item: any) => {
                return item.value === value;
              })?.label
            }
          </>
        );
      }
    },
    {
      title: RawMaterialLabel.VOLUME_MATERIAL,
      dataIndex: RawMaterialKey.VOLUME_MATERIAL,
      width: 120,
      render: (value: any) => {
        return formatIndian(value);
      }
    },
    {
      title: RawMaterialLabel.DISTANCE,
      dataIndex: RawMaterialKey.DISTANCE,
      width: 120,
      render: (value: any) => {
        return formatIndian(value);
      }
    }
  ];

  return (
    <Table
      bordered={false}
      columns={columns}
      dataSource={dataSource}
      pagination={{pageSize: 50}}
      scroll={{y: 240}}
      rowKey={RawMaterialKey.SUPPLIER_ID}
      // tableLayout="auto"
    />
  );
};

export default RawMaterialDis;
